import { Editor } from '@tiptap/core';
import { FC, useCallback } from 'react';
import styled from 'styled-components';
import { BasicFormattingCommands } from './basic-formatting-commands';
import {
  BoldButton,
  UnderlineButton,
  ItalicButton,
  StrikethroughButton,
} from './basic-mark-commands';
import { DefaultFloatingToolbarConfig } from './types';
import { SelectionActionPopover } from '../editor-popover/selection-action-popover';
import { EditorPopoverContentProps } from '../editor-popover/types';

interface EditorDefaultToolbar {
  editor: Editor;
  closePopover: () => void;
  config?: DefaultFloatingToolbarConfig;
}
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-02);
`;

export const EditorDefaultToolbar: FC<EditorDefaultToolbar> = ({
  editor,
  closePopover,
}) => {
  return (
    <Wrapper>
      <BasicFormattingCommands
        editor={editor}
        afterCommandExecuted={closePopover}
      />
      <BoldButton editor={editor} afterCommandExecuted={closePopover} />
      <ItalicButton editor={editor} afterCommandExecuted={closePopover} />
      <UnderlineButton editor={editor} afterCommandExecuted={closePopover} />
      <StrikethroughButton
        editor={editor}
        afterCommandExecuted={closePopover}
      />
    </Wrapper>
  );
};
interface FloatingToolbarProps {
  editor: Editor;
  config?: DefaultFloatingToolbarConfig;
}
export const FloatingToolbar: FC<FloatingToolbarProps> = ({
  editor,
  config,
}) => {
  const renderContent = useCallback(
    ({ editor, closePopover }: EditorPopoverContentProps) => (
      <EditorDefaultToolbar
        editor={editor}
        closePopover={closePopover}
        config={config}
      />
    ),
    [config],
  );

  return (
    <SelectionActionPopover
      popoverContentContainerClassName={'test'}
      editor={editor}
      content={renderContent}
    />
  );
};
